import { api, errorFn } from "@/common/apiService";
import {
  DISPLAY_NOTIFICATION,
  CLEAR_NOTIFICATION,
  ADD_NOTIFICATION,
  FETCH_BANKS,
  FETCH_ROUTES,
  FETCH_TERMINAL_TYPES,
  FETCH_TERMINAL_APPS,
  FETCH_BUSINESS_TYPES,
  GET_COMMON_DATA,
} from '../actions/common';

const state = {
  notifications: [],
  notification: {
    message: "",
    url: "",
    timeout: 5000,
    color: "primary",
    show: false,
    commit: false
  },
  banks: [],
  routes: [],
  terminalTypes: [],
  terminalApps: [],
  businessTypes: [],
}

const getters = {
  // getUnreadNotifications
  // getNotifications
}

const mutations = {
  [DISPLAY_NOTIFICATION]: (state, notification) => {
    state.notification = { ...notification }
  },
  [CLEAR_NOTIFICATION]: (state, id) => {
    let index = state.notifications.findIndex(notification => notification.id == id);
    state.notifications.splice(index, 1)
  },
  [ADD_NOTIFICATION]: (state, notification) => {
    state.notifications.push(notification)
  },
  [FETCH_BANKS]: (state, bankList) => {
    state.banks = [...bankList]
  },
  [FETCH_ROUTES]: (state, routeList) => {
    state.routes = [...routeList]
  },
  [FETCH_TERMINAL_TYPES]: (state, terminalTypes) => {
    state.terminalTypes = [...terminalTypes];
  },
  [FETCH_TERMINAL_APPS]: (state, terminalApps) => {
    state.terminalApps = [...terminalApps];
  },
  [FETCH_BUSINESS_TYPES]: (state, businessTypes) => {
    state.businessTypes = [...businessTypes];
  },
}

const actions = {
  [DISPLAY_NOTIFICATION]: ({ commit, dispatch }, notification) => {
    notification = { ...notification, id: state.notifications.length }
    commit(DISPLAY_NOTIFICATION, notification)
    if (notification.commit) {
      commit(ADD_NOTIFICATION, notification)
    }
  },
  [CLEAR_NOTIFICATION]: ({ commit, dispatch }, id) => {
    commit(CLEAR_NOTIFICATION, id)
  },

  [FETCH_BANKS]: ({ commit, dispatch, rootState }) => {
    return api.get('/banks/').then((resp) => {
      commit(FETCH_BANKS, resp.data)
    }).catch(errorFn)
  },
  [FETCH_TERMINAL_TYPES]: ({ commit, dispatch, rootState }) => {
    return api.get('/terminal-types/').then((resp) => {
      commit(FETCH_TERMINAL_TYPES, resp.data)
    }).catch(errorFn)
  },
  [FETCH_TERMINAL_APPS]: ({ commit, dispatch, rootState }) => {
    return api.get('/terminal-apps/').then((resp) => {
      commit(FETCH_TERMINAL_APPS, resp.data)
    }).catch(errorFn)
  },
  [FETCH_BUSINESS_TYPES]: ({ commit, dispatch, rootState }) => {
    return api.get('/business-types/').then((resp) => {
      commit(FETCH_BUSINESS_TYPES, resp.data)
    }).catch(errorFn)
  },
  [FETCH_ROUTES]: ({ commit, dispatch, rootState }) => {
    return api.get('/routes/').then((resp) => {
      commit(FETCH_ROUTES, resp.data)
    }).catch(errorFn)
  },
  [GET_COMMON_DATA]: async ({ commit, dispatch, rootState }) => {
    dispatch(FETCH_BANKS);
    dispatch(FETCH_BUSINESS_TYPES);
    dispatch(FETCH_TERMINAL_TYPES);
    dispatch(FETCH_TERMINAL_APPS);
  },
}

export default {
  state, getters, mutations, actions
};

